document.addEventListener('DOMContentLoaded', () => {
  const els = [...document.querySelectorAll('.reveal')];
  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('is-visible'));
  } else {
    const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    }), { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
  }
});

function setMobileMenu(button, menu, open) {
  if (!button || !menu) return;
  button.setAttribute('aria-expanded', String(open));
  button.setAttribute('aria-label', open ? 'Close navigation menu' : 'Open navigation menu');
  menu.hidden = !open;
  menu.classList.toggle('is-open', open);
  document.documentElement.classList.toggle('mobile-menu-open', open);
  document.body.classList.toggle('mobile-menu-open', open);

  if (open) {
    window.requestAnimationFrame(() => {
      menu.querySelector('.mobile-menu__close, a, button:not(.mobile-menu__backdrop)')?.focus();
    });
  }
}

function closeAllMobileMenus() {
  document.querySelectorAll('[data-mobile-menu].is-open').forEach((menu) => {
    const button = document.querySelector(`[aria-controls="${menu.id}"]`);
    setMobileMenu(button, menu, false);
  });
}

document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('.menu-button');
  if (menuButton) {
    event.preventDefault();
    const menu = document.getElementById(menuButton.getAttribute('aria-controls'));
    if (!menu) return;
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    closeAllMobileMenus();
    setMobileMenu(menuButton, menu, open);
    return;
  }

  const closeButton = event.target.closest('[data-mobile-menu-close]');
  if (closeButton) {
    event.preventDefault();
    const menu = closeButton.closest('[data-mobile-menu]');
    const button = menu && document.querySelector(`[aria-controls="${menu.id}"]`);
    setMobileMenu(button, menu, false);
    button?.focus();
    return;
  }

  const mobileToggle = event.target.closest('.mobile-submenu-toggle');
  if (mobileToggle) {
    event.preventDefault();
    event.stopPropagation();
    const submenu = document.getElementById(mobileToggle.getAttribute('aria-controls'));
    if (!submenu) return;
    const open = mobileToggle.getAttribute('aria-expanded') !== 'true';
    mobileToggle.setAttribute('aria-expanded', String(open));
    const label = mobileToggle.closest('.mobile-cart') ? 'cart details' : 'submenu';
    mobileToggle.setAttribute('aria-label', `${open ? 'Close' : 'Open'} ${label}`);
    mobileToggle.classList.toggle('is-open', open);
    submenu.hidden = !open;
    return;
  }

  const desktopToggle = event.target.closest('.submenu-toggle');
  if (desktopToggle) {
    event.preventDefault();
    event.stopPropagation();
    const item = desktopToggle.closest('.nav-item');
    const nav = desktopToggle.closest('.nav');
    nav?.querySelectorAll('.nav-item.is-open').forEach((openItem) => {
      if (openItem !== item) {
        openItem.classList.remove('is-open');
        openItem.querySelector(':scope > .nav-link-row .submenu-toggle')?.setAttribute('aria-expanded', 'false');
      }
    });
    const open = item.classList.toggle('is-open');
    desktopToggle.setAttribute('aria-expanded', String(open));
    return;
  }

  document.querySelectorAll('.nav-item.is-open').forEach((item) => {
    item.classList.remove('is-open');
    item.querySelector(':scope > .nav-link-row .submenu-toggle')?.setAttribute('aria-expanded', 'false');
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openMenu = document.querySelector('[data-mobile-menu].is-open');
  if (openMenu) {
    const button = document.querySelector(`[aria-controls="${openMenu.id}"]`);
    setMobileMenu(button, openMenu, false);
    button?.focus();
  }
  document.querySelectorAll('.nav-item.is-open').forEach((item) => {
    item.classList.remove('is-open');
    item.querySelector(':scope > .nav-link-row .submenu-toggle')?.setAttribute('aria-expanded', 'false');
  });
});

window.addEventListener('resize', () => {
  if (window.innerWidth > 900) closeAllMobileMenus();
});

document.addEventListener('shopify:section:unload', closeAllMobileMenus);

// Header search/cart popover
function closeHeaderPopovers(exceptButton) {
  document.querySelectorAll('.header-popover-toggle[aria-expanded="true"]').forEach((button) => {
    if (button === exceptButton) return;
    button.setAttribute('aria-expanded', 'false');
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (panel) panel.hidden = true;
  });
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.header-popover-toggle');
  if (toggle) {
    event.preventDefault();
    event.stopPropagation();
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    closeHeaderPopovers(toggle);
    toggle.setAttribute('aria-expanded', String(open));
    if (panel) {
      panel.hidden = !open;
      if (open) panel.querySelector('input,button,a')?.focus();
    }
    return;
  }
  if (!event.target.closest('.header-popover')) closeHeaderPopovers();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeHeaderPopovers();
});

// AJAX cart and quick add
const fairwakeCartRoot = () => window.Shopify?.routes?.root || '/';

function escapeCartHtml(value = '') {
  return String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

function formatCartMoney(cents, currency = 'USD') {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency
    }).format((Number(cents) || 0) / 100);
  } catch (_) {
    return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
  }
}

function renderFreeShippingMeter(cart) {
  const config = window.FairwakeTheme || {};
  const threshold = Number(config.freeShippingThreshold) || 0;
  if (!config.freeShippingEnabled || threshold <= 0) return '';
  const total = Number(cart?.total_price) || 0;
  const remaining = Math.max(0, threshold - total);
  const progress = Math.max(0, Math.min(100, (total / threshold) * 100));
  const message = remaining > 0
    ? `${escapeCartHtml(config.freeShippingBefore || "You're")} <strong>${formatCartMoney(remaining, cart?.currency)}</strong> ${escapeCartHtml(config.freeShippingAfter || 'away from free shipping.')}`
    : `<span class="fw-shipping-meter__unlocked"><svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m4 10.5 3.5 3.5L16 5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>${escapeCartHtml(config.freeShippingSuccess || 'Free shipping unlocked.')}</span>`;
  return `<div class="fw-shipping-meter" data-free-shipping-meter data-threshold="${threshold}" data-cart-total="${total}"><div class="fw-shipping-meter__message" data-shipping-message><span>${message}</span></div><div class="fw-shipping-meter__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}" aria-label="Free shipping progress"><span class="fw-shipping-meter__fill" data-shipping-fill style="width:${progress}%"></span></div></div>`;
}

function renderHeaderCart(cart, showRemove = true) {
  const root = fairwakeCartRoot();
  if (!cart || cart.item_count === 0) {
    return `
      ${renderFreeShippingMeter(cart)}
      <p>Your cart is currently empty.</p>
      <div class="header-cart-actions header-cart-actions--single">
        <a href="${root}collections/all">Continue shopping</a>
      </div>
    `;
  }

  const itemsHtml = cart.items.slice(0, 4).map((item) => {
    const title = escapeCartHtml(item.product_title || item.title || 'Item');
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? ` · ${escapeCartHtml(item.variant_title)}`
      : '';
    const image = item.image
      ? `<img src="${escapeCartHtml(item.image)}" alt="${title}" width="54" height="64" loading="lazy">`
      : '';

    return `
      <div class="header-cart-item" data-cart-item-key="${escapeCartHtml(item.key)}">
        ${image}
        <div class="header-cart-item__details">
          <a class="header-cart-name" href="${escapeCartHtml(item.url)}">${title}</a>
          <div class="header-cart-meta">Qty ${Number(item.quantity) || 1}${variant}</div>
        </div>
        <div class="header-cart-item__aside">
          <span>${formatCartMoney(item.final_line_price, cart.currency)}</span>
          ${showRemove ? `<button class="header-cart-remove" type="button" data-cart-remove="${escapeCartHtml(item.key)}" aria-label="Remove ${title} from cart"><svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 3.5l9 9m0-9-9 9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button>` : ''}
        </div>
      </div>
    `;
  }).join('');

  return `
    ${renderFreeShippingMeter(cart)}
    <div class="header-cart-items" aria-live="polite">${itemsHtml}</div>
    <div class="header-cart-total"><span>Subtotal</span><strong>${formatCartMoney(cart.total_price, cart.currency)}</strong></div>
    <div class="header-cart-actions">
      <a href="${root}cart">View cart</a>
      <a class="checkout" href="${root}checkout">Checkout</a>
    </div>
  `;
}

function updateCartInterfaces(cart) {
  document.querySelectorAll('.cart-count').forEach((badge) => {
    badge.textContent = cart.item_count;
    badge.hidden = false;
  });
  document.querySelectorAll('[data-cart-count]').forEach((count) => {
    count.textContent = cart.item_count;
  });
  document.querySelectorAll('[id^="HeaderCart-"], [id^="MobileCart-"]').forEach((panel) => {
    panel.innerHTML = renderHeaderCart(cart, panel.dataset.cartRemoveEnabled !== 'false');
  });
}

async function fetchLiveCart() {
  const response = await fetch(`${fairwakeCartRoot()}cart.js`, {
    cache: 'no-store',
    headers: { Accept: 'application/json' }
  });
  if (!response.ok) throw new Error('Unable to refresh the cart.');
  return response.json();
}

async function refreshCartCount() {
  try {
    const cart = await fetchLiveCart();
    updateCartInterfaces(cart);
    return cart;
  } catch (_) {
    return null;
  }
}

async function openAndRefreshCartPopover() {
  const cartToggle = document.querySelector('.header-popover-toggle[aria-controls^="HeaderCart"]');
  if (!cartToggle) return;

  const panel = document.getElementById(cartToggle.getAttribute('aria-controls'));
  if (!panel) return;

  closeHeaderPopovers(cartToggle);
  cartToggle.setAttribute('aria-expanded', 'true');
  panel.hidden = false;
  panel.setAttribute('aria-busy', 'true');

  try {
    const cart = await fetchLiveCart();
    updateCartInterfaces(cart);
  } catch (_) {
    panel.innerHTML = '<p>Unable to refresh the cart. Please open the full cart page.</p>';
  } finally {
    panel.removeAttribute('aria-busy');
  }
}

document.addEventListener('click', async (event) => {
  const removeButton = event.target.closest('[data-cart-remove]');
  if (!removeButton) return;

  event.preventDefault();
  event.stopPropagation();
  const itemKey = removeButton.getAttribute('data-cart-remove');
  if (!itemKey || removeButton.disabled) return;

  removeButton.disabled = true;
  removeButton.setAttribute('aria-busy', 'true');
  const itemRow = removeButton.closest('.header-cart-item');
  itemRow?.classList.add('is-removing');

  try {
    const response = await fetch(`${fairwakeCartRoot()}cart/change.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    });
    const cart = await response.json();
    if (!response.ok) throw new Error(cart.description || 'Unable to remove this item.');
    updateCartInterfaces(cart);
  } catch (error) {
    itemRow?.classList.remove('is-removing');
    removeButton.disabled = false;
    removeButton.removeAttribute('aria-busy');
    window.alert(error.message || 'Unable to remove this item.');
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add-form]');
  if (!form) return;
  event.preventDefault();

  const button = form.querySelector('.quick-add-button');
  const status = form.querySelector('.quick-add-status');
  if (!button || button.disabled) return;

  const originalLabel = button.dataset.defaultLabel || 'Quick add';
  const label = button.querySelector('.quick-add-button__label');
  button.classList.add('is-loading');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.setAttribute('aria-label', 'Adding item to cart');
  if (label) label.textContent = 'Adding item to cart';
  if (status) status.textContent = '';

  try {
    const response = await fetch(`${fairwakeCartRoot()}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Unable to add this item.');

    button.classList.remove('is-loading');
    button.classList.add('is-added');
    button.removeAttribute('aria-busy');
    button.setAttribute('aria-label', 'Added to cart');
    if (label) label.textContent = 'Added to cart';
    if (status) status.textContent = `${data.product_title || 'Item'} added to cart.`;
    await openAndRefreshCartPopover();

    window.setTimeout(() => {
      button.classList.remove('is-added');
      button.disabled = false;
      button.setAttribute('aria-label', originalLabel);
      if (label) label.textContent = originalLabel;
      if (status) status.textContent = '';
    }, 1800);
  } catch (error) {
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    button.disabled = false;
    button.setAttribute('aria-label', originalLabel);
    if (label) label.textContent = originalLabel;
    if (status) status.textContent = error.message || 'Unable to add this item.';
  }
});

// Signal Ridge collection tabs
function initSignalTabs(scope = document) {
  scope.querySelectorAll('[data-signal-tabs]').forEach((section) => {
    if (section.dataset.tabsReady === 'true') return;
    section.dataset.tabsReady = 'true';
    const tabs = [...section.querySelectorAll('[role="tab"]')];
    const panels = [...section.querySelectorAll('[role="tabpanel"]')];
    const activate = (tab) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        tabs[next].focus();
        activate(tabs[next]);
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initSignalTabs());
document.addEventListener('shopify:section:load', (event) => initSignalTabs(event.target));

// Optional global scroll progress signal
function updateSignalProgress() {
  const bar = document.querySelector('[data-signal-progress]');
  if (!bar) return;
  const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
  bar.style.width = `${Math.min(100, Math.max(0, (window.scrollY / max) * 100))}%`;
}
window.addEventListener('scroll', updateSignalProgress, { passive: true });
window.addEventListener('resize', updateSignalProgress);
document.addEventListener('DOMContentLoaded', updateSignalProgress);

window.FairwakeFeatures={darkMode:true,freeShipping:true,dropCountdown:true};